__turbopack_context__.v({
  "className": "yPVgJa_className",
  "variable": "yPVgJa_variable",
});
